import { render, staticRenderFns } from "./InvoiceSettings.vue?vue&type=template&id=92acd806&"
import script from "./InvoiceSettings.vue?vue&type=script&lang=ts&"
export * from "./InvoiceSettings.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports